import React from 'react';
import injectSheet from 'react-jss';

import Paper from '@material-ui/core/Paper';

const NothingFound = ({ classes }) => (
    <Paper square elevation={1} className={classes.wrapper}>
        Nothing found!
    </Paper>
);

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: [0, spacing.unit * 4],
        marginTop: spacing.unit * 6,
    },
});

export default injectSheet(style)(NothingFound);



// WEBPACK FOOTER //
// ./src/components/NothingFound.js